import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const QuickSearchIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M6.29086 8.87284C5.57796 8.15994 5.57796 7.00411 6.29086 6.29121C7.00376 5.57831 8.15959 5.57831 8.87249 6.29121L17.5182 14.9369C18.231 15.6498 18.231 16.8056 17.5182 17.5185C16.8053 18.2314 15.6494 18.2314 14.9365 17.5185L6.29086 8.87284Z"
        fill="var(--cdl-accent-bg-base)"
      />
      <path
        d="M8.28296 6.88056C7.89549 6.49319 7.26745 6.49313 6.88002 6.88056C6.49268 7.26799 6.49268 7.89605 6.88002 8.28349L15.5255 16.929L15.6009 16.9975C15.9906 17.3153 16.5657 17.2927 16.929 16.9296C17.3165 16.5421 17.3159 15.9135 16.9284 15.526L8.28296 6.88056ZM18.107 14.3475C19.1453 15.3859 19.1459 17.0697 18.1075 18.1081C17.1017 19.1138 15.4902 19.1452 14.4465 18.2024L14.347 18.1075L5.70151 9.462C4.6633 8.42369 4.6633 6.74036 5.70151 5.70204C6.73981 4.66374 8.42312 4.6638 9.46147 5.70204L18.107 14.3475Z"
        fill="var(--cdl-accent-bg-base)"
      />
      <path
        d="M14.1666 7.70866C14.1666 11.2755 11.2751 14.167 7.70829 14.167C4.14145 14.167 1.24996 11.2755 1.24996 7.70866C1.24996 4.14182 4.14145 1.25033 7.70829 1.25033C11.2751 1.25033 14.1666 4.14182 14.1666 7.70866Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        d="M7.70829 13.3337C4.60169 13.3337 2.08329 10.8153 2.08329 7.70866C2.08329 4.60206 4.60169 2.08366 7.70829 2.08366C10.8149 2.08366 13.3333 4.60206 13.3333 7.70866C13.3333 10.8153 10.8149 13.3337 7.70829 13.3337ZM7.70829 15.0003C11.7354 15.0003 15 11.7357 15 7.70866C15 3.68158 11.7354 0.416992 7.70829 0.416992C3.68122 0.416992 0.416626 3.68158 0.416626 7.70866C0.416626 11.7357 3.68122 15.0003 7.70829 15.0003Z"
        fill="currentColor"
      />
      <path
        d="M4.88281 12.8439L12.8437 4.88281C13.998 7.27749 13.7373 10.1834 11.9466 11.9741C10.1559 13.7649 7.22033 13.8304 4.88281 12.8439Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default QuickSearchIcon;
